import {IDataTableColumn, DataTableColumnType} from '../../components/ts-data-table';
import {IHistoryConsoleResult} from './controller';

export const defaultSessionsColumns: IDataTableColumn<IHistoryConsoleResult>[] = [
    {
        accessorKey: 'date',
        header: 'Date',
        type: DataTableColumnType.DateTime,
        size: 50
    },
    {
        accessorKey: 'sessionId',
        header: 'Session ID',
        type: DataTableColumnType.String,
        size: 1
    },
    {
        accessorKey: 'sessionDuration',
        header: 'Duration',
        type: DataTableColumnType.Duration,
        size: 1
    }
];
